import { formatBooleanValue } from "../../util";
import IndexAttributeData from "../model/IndexAttributeData";

const IndexAttributeDataMapper = (item: any) => {
  let indexTypeAttribute = IndexAttributeData(item);
  indexTypeAttribute.valid = formatBooleanValue(item.valid);
  return indexTypeAttribute;
};

export default IndexAttributeDataMapper;
